export default {
    videos: 'Videos',
    data_consumed: 'Data consumed (mb)',
    size: 'Size (Mb)',
    lms_link: 'LMS Link',
    video: 'Video',
    no_file: 'There is no file',
    text_upload_file: 'Start uploading a new file.',
    upload: 'Upload',
}